import { utagLinkAddToCart as utagLinkGa4AddToCart } from 'features/tealium/ga4/ecommerce';

import utagLinkAddToCart from './utagLinkAddToCart';
import { getSelectedUtagData } from './utils';

function utagLinkAddRecommendedBulbs (response) {

	if (window.utag) {

		// we have to track ONLY recomended bulbs, but backend returns utag_data for a WHOLE cart
		// so here we select only data related to recomeneded bulbs from utag_data
		const recommendedBulbs = response.GlobalCartResponseModel.ProductItems.filter(
			(productItem) => productItem.BulbParentSkuId > 0
		);
		const recommendedBulbsIndexes = recommendedBulbs.map((rb) => window.utag_data.product_sku.indexOf(rb.ShortSku));

		const tag = { ...window.utag_data, ...getSelectedUtagData(window.utag_data, recommendedBulbsIndexes) };
		const utagLinkTrackingData = utagLinkAddToCart(tag);
		window.utag.link(utagLinkTrackingData);
		const utagLinkGa4TrackingData = utagLinkGa4AddToCart(tag);
		window.utag.link(utagLinkGa4TrackingData);

	}

}

export default utagLinkAddRecommendedBulbs;
